import { minuteMs } from "verdi-common/timeConstants";

export const BASE_UNIT_VALUE = minuteMs;

export const TOGGLE_GROUP_ACTIVE_CLASS = "*:data-pressed:bg-primary! *:data-pressed:text-primary-foreground!";
